import type {Editor} from 'grapesjs';
import {getUniqueId} from '@Utils/string.util';
import {initializeEditor} from '@EmailMakerReact/grapesjs-email-maker-plugin/main';

export interface MountEditorArgs {
  container: HTMLElement;
  plugin: (editor: Editor) => void;
}

const POLLING_EVENT_ID_MODEL_KEY = 'pmwEmailMakerPollingEventId';

export function mountEditor({container, plugin}: MountEditorArgs): Editor {
  return initializeEditor(container, plugin);
}

export function destroyEditor(editor: Editor): void {
  editor.destroy();
}

export function waitForEditorLoad(editor: Editor): Promise<void> {
  return new Promise((resolve) => {
    const handler = (): void => {
      editor.off('load', handler);
      resolve();
    };
    editor.on('load', handler);
  });
}

/** Shared id every email maker polling loop registers under, so {@link stopEmailMakerPolling} can halt them all on teardown. */
export function getEmailMakerPollingEventId(editor: Editor): string {
  const existingEventId = editor.getModel().get(POLLING_EVENT_ID_MODEL_KEY) as string | undefined;
  if (existingEventId) {
    return existingEventId;
  }

  const eventId = `email-maker-polling-${getUniqueId()}`;
  editor.getModel().set(POLLING_EVENT_ID_MODEL_KEY, eventId);
  return eventId;
}

export function stopEmailMakerPolling(editor: Editor): void {
  document.dispatchEvent(new Event(window.PMW.getPollingStopEvent(getEmailMakerPollingEventId(editor))));
}
